import Moment from 'moment';
import { DATE_FORMAT, MIN_DATE_FORMATTED } from '../constants/constants';

export const getMilestoneIds = (isMilestone) => {
    if (isMilestone === true) {
        return '1'; // Milestones option
    } else if (isMilestone === false) {
        return '0'; // Non-Milestones option
    } else {
        return ''; // Default to no selected options
    }
}

export const getDateValue = (date) => {
    if (date) {
        const formatted = Moment.utc(date).format(DATE_FORMAT);
        if (formatted === MIN_DATE_FORMATTED) {
            return '';
        } else {
            return formatted;
        }
    }
    return '';
}
